import { Box, type SxProps, type Theme } from "@mui/material";

import FernieFace from "~/components/fernie/FernieFace";
import FernieName from "~/components/fernie/FernieName";
import { clampMarkSize, type FernieFaceState } from "~/components/fernie/fernieMarkRules";
import { fernieColors } from "~/themes/fernieBrand";

interface FernieLockupProps {
	state?: FernieFaceState;
	size?: number;
	trademark?: boolean;
	nameColor?: string;
	sx?: SxProps<Theme>;
}

const FernieLockup = ({
	state = "rest",
	size = 64,
	trademark = true,
	nameColor = fernieColors.tile,
	sx
}: FernieLockupProps) => {
	const width = clampMarkSize("lockup", size);

	return (
		<Box
			sx={{ alignItems: "center", display: "inline-flex", flexDirection: "column", gap: `${width * 0.08}px`, ...sx }}
		>
			<FernieFace state={state} size={width} decorative />
			<FernieName trademark={trademark} color={nameColor} fontSize={width * 0.3} />
		</Box>
	);
};

export default FernieLockup;
